import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

/** The 8 fixed `Features` keys (`packages/core/core/manifest.ts`) — order matches
 *  the `Features` interface itself. */
const FEATURE_KEYS = [
  "tts",
  "print",
  "present",
  "bookmark",
  "nav",
  "saveImages",
  "remind",
  "kiosk",
] as const;

const UNSET = "__unset__";

/**
 * `kind: "featureFlags"` — 8 tri-state rows for the `Features` partial object
 * (`{tts?,print?,...}`). Absent keys are omitted from the emitted object entirely
 * (never `{tts: undefined}`), and an all-absent result collapses `features` itself
 * to `undefined` on the parent draft (handled by `onChange` below).
 */
export function FeaturesSectionEditor({
  label,
  value,
  onChange,
}: {
  label: string;
  value: unknown;
  onChange: (v: unknown) => void;
}) {
  const obj = value && typeof value === "object" ? (value as Record<string, unknown>) : {};

  const setKey = (key: string, next: boolean | undefined) => {
    const nextObj = { ...obj };
    if (next === undefined) delete nextObj[key];
    else nextObj[key] = next;
    onChange(Object.keys(nextObj).length > 0 ? nextObj : undefined);
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {label}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
        {FEATURE_KEYS.map((key) => {
          const v = obj[key];
          const current = v === true ? "true" : v === false ? "false" : UNSET;
          return (
            <TextField
              key={key}
              select
              size="small"
              label={key}
              sx={{ minWidth: 150 }}
              value={current}
              onChange={(e) => setKey(key, e.target.value === UNSET ? undefined : e.target.value === "true")}
            >
              <MenuItem value={UNSET}>
                <em>(default)</em>
              </MenuItem>
              <MenuItem value="true">On</MenuItem>
              <MenuItem value="false">Off</MenuItem>
            </TextField>
          );
        })}
      </Box>
    </Box>
  );
}
